import React, { useState, useEffect } from "react";
import { useRecoilState, useSetRecoilState } from "recoil";
import PageTitle from "../../components/DefaultStyles/PageTitle";
import ChatReportComplete from "../../components/pages/Party/ChatInfo/ChatReportComplete";
import ChatSearch from "../../components/pages/Party/ChatInfo/ChatSearch";
import RecentChatAll from "../../components/pages/Party/ChatInfo/RecentChatAll";
import ChatTab, {
  chatTabState,
} from "../../components/pages/Party/ChatInfo/ChatTab";
import OldRecentChatAll from "../../components/pages/Party/ChatInfo/Old/OldRecentChatAll";
import OldChatSearch from "../../components/pages/Party/ChatInfo/Old/OldChatSearch";
import { useLocation } from "react-router-dom";
import { recentChatBtnClick } from "../../components/pages/Party/ChatInfo/ChatSearch/ChatSearchResult";

export const isNewChat = true;

export default function ChatInfo() {
  const [chatTab, setChatTab] = useRecoilState(chatTabState);
  const { search } = useLocation();
  const [isFirebaseChat, setIsFirebaseChat] = useState(false);
  const setRecentBtnClick = useSetRecoilState(recentChatBtnClick);

  const toggleButtonEvent = () => {
    setIsFirebaseChat((prev) => !prev);
  };

  useEffect(() => {
    if (search?.includes("@")) {
      setChatTab(1);
      setRecentBtnClick(true);
    }
  }, [search]);

  return (
    <>
      <PageTitle title="파티 채팅" />

      <ChatTab
        isFirebaseChat={isFirebaseChat}
        toggleButtonEvent={toggleButtonEvent}
      />

      {chatTab === 0 ? (
        isNewChat && !isFirebaseChat ? (
          <RecentChatAll />
        ) : (
          <OldRecentChatAll />
        )
      ) : chatTab === 1 ? (
        isNewChat ? (
          <ChatSearch />
        ) : (
          <OldChatSearch />
        )
      ) : (
        <ChatReportComplete />
      )}
    </>
  );
}
